import { useEffect, useState, useRef } from 'react';
import Loader from 'react-loaders';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import emailjs from '@emailjs/browser';
import Lightning from './lightning';
import AnimatedLetters from '../AnimatedLetters';
import './index.scss';
const EMAILJS_SERVICE_ID = 'service_6nnl31m'
const EMAILJS_TEMPLATE_ID = 'template_nl5a1o8'
const EMAILJS_PUBLIC_KEY = '-uH5l5-qO91rZBcDT'

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const [isLoading, setIsLoading] = useState(false);
    const form = useRef();
    const isMobile = window.matchMedia('(max-width: 768px)').matches

    useEffect(() => {
        emailjs.init(EMAILJS_PUBLIC_KEY)
        const timeoutId = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 3000);
        return () => clearTimeout(timeoutId);
    }, []);

    const sendEmail = async (e) => {
        e.preventDefault()
        setIsLoading(true)

        try {
            const payload = {
                name: form.current.name.value,
                email: form.current.email.value,
                subject: form.current.subject.value,
                message: form.current.message.value,
            }

            console.log('EmailJS payload:', payload)

            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                payload
            )

            alert('Message sent successfully')
            form.current.reset()
        } catch (err) {
            console.error('EmailJS FULL error:', err)
            alert(err?.text || err?.message || JSON.stringify(err))
        } finally {
            setIsLoading(false)
        }
    }


    return (
        <>
            {!isMobile && <Lightning />}
            <div className="container contact-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        If you have a problem worth solving or a question to explore, you can reach out using the form below.
                    </p>
                    <div className="contact-form">
                        <form ref={form} onSubmit={sendEmail}>
                            <ul>
                                <li className="half">
                                    <input placeholder="Name" type="text" name="name" required aria-label="Name" />
                                </li>
                                <li className="half">
                                    <input placeholder="Email" type="email" name="email" required aria-label="Email" />
                                </li>
                                <li>
                                    <input placeholder="Subject" type="text" name="subject" required aria-label="Subject" />
                                </li>
                                <li>
                                    <textarea placeholder="Message" name="message" required aria-label="Message" />
                                </li>
                                <li>
                                    <input
                                        type="submit"
                                        className="flat-button"
                                        value={isLoading ? 'SENDING...' : 'SEND'}
                                        disabled={isLoading}
                                    />
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
                {}
            </div>
            <Loader type="pacman" />
        </>
    );
};

export default Contact;